import TableCellRenderer from "../../table/TableCellRenderer";

export default class LockTableCellRenderer extends TableCellRenderer{
    updateUI(cell) {
        let className = [
            this.getCellClassName(cell),
            this.getTopBorderClassName(cell),
            this.getRightBorderClassName(cell),
            this.getLeftBorderClassName(cell),
            this.getComplicatedBorderClassName(cell)
        ].join(" ");
        this.setCssClass(cell, className);
    }

    getComplicatedBorderClassName(cell) {
        return "";
    }

    getTopBorderClassName(cell) {
        let selectionController = this.getSelectionController(cell);
        if (this.isSelected(cell)) {
            if (selectionController.isUpwardmostSelectedCell(cell) &&
                selectionController.visitSelection(this.getSelectionTopBorderChecker()))
                return "selectionTopBorder";
        }
        else {
            let upperRowIdx = cell.getRow().getRowIdx() - 1;
            if (upperRowIdx > 0) {
                let upperCell = cell.getRow().getTable().getCell(upperRowIdx, cell.getColIdx());
                if (selectionController.isDownwardmostSelectedCell(upperCell) &&
                    this.shouldDrawSelectionTopBorder(selectionController))
                    return "selectionTopBorder";
            }
        }
        return "";
    }

    getRightBorderClassName(cell) {
        if (this.isLastCell(cell)) {
            if (this.isSelected(cell) &&
                this.getSelectionController(cell).visitSelection(this.getSelectionRightBorderChecker(cell))) {
                return "selectionRightBorder";
            }
            else {
                return this.getLastCellRightBorderClassName();
            }
        }
        return "";
    }

    getLastCellRightBorderClassName() {
        return "lockTableRightBorder";
    }

    getSelectionLeftBorderChecker(cell) {
        return {
            visitCellSelection() { return true; },
            visitDateSelection() { return true; },
            visitRunnerSelection() {
                let runnerController = cell.getRow().getTable().getRunnerController();
                return runnerController.getLastLockedDate() != null &&
                       runnerController.getNewLastLockDate() < runnerController.getLastLockedDate();
            }
        };
    }

    shouldDrawSelectionTopBorder(selectionController) {
        return selectionController.visitSelection({
            visitCellSelection() { return true; },
            visitDateSelection() { return false; },
            visitRunnerSelection() { return false; }
        });
    }

    getSelectionTopBorderChecker() {
        return {
            visitCellSelection() { return true; },
            visitDateSelection() { return false; },
            visitRunnerSelection() { return false; }
        };
    }

    getSelectionRightBorderChecker(cell) {
        return {
            visitCellSelection() { return true; },
            visitDateSelection() { return true; },
            visitRunnerSelection() {
                let runnerController = cell.getRow().getTable().getRunnerController();
                return runnerController.getLastLockedDate() == null ||
                       runnerController.getNewLastLockDate() > runnerController.getLastLockedDate();
            }
        };
    }

    getLeftBorderClassName(cell) {
        let selectionController = this.getSelectionController(cell);
        if (this.isSelected(cell)) {
            if (selectionController.isLeftmostSelectedCell(cell)) {
                if (selectionController.visitSelection(this.getSelectionLeftBorderChecker(cell)))
                    return "selectionLeftBorder";
            }
        }
        else {
            let leftColIdx = cell.getColIdx() - 1;
            if (leftColIdx > 0) {
                if (selectionController.isRightmostSelectedCell(cell.getRow().getCell(leftColIdx)) &&
                    selectionController.visitSelection(this.getSelectionRightBorderChecker(cell)))
                    return "selectionLeftBorder";
            }
        }

        if (cell.getColIdx() > 1) {
            if (this.isFirstCellOfWeek(cell))
                return this.getWeekSeparatorClass();
        }
        return this.getLeftBorderSpecificClassName(cell);
    }

    getLeftBorderSpecificClassName(cell) {
        return "";
    }

    getWeekSeparatorClass(cell) {
        return "weekSeparator";
    }

    isFirstCellOfWeek(cell) {
        let columnHeader = cell.getRow().getTable().getFirstRow().getCell(cell.getColIdx());
        return columnHeader.getValue().date.getDay() == cell.getRow().getTable().getWeekStartDay();
    }

    getCellClassName(cell) {
        //Note: should be implemented in inheritors
    }

    isHovered(cell) {
        return cell.getRow().getTable().getHoverController().isHovered(cell);
    }

    isLastCell(cell) {
        return cell.getRow().getCells().length - 1 == cell.getColIdx();
    }

    isWorkingCell(cell) {
        return cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().working;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/LockTableCellRenderer.js